export default __webpack_public_path__ + "static/media/efim.a46c34ad.jpg";